const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * True when `value` is a canonical UUID string. Rocky rejects non-UUID id
 * values before it ever looks them up — GraphQL with a type error, REST with a
 * 400 — so any id taken from a URL, a model response, or user input must be
 * guarded here before it reaches an id-shaped Rocky parameter. Accepts
 * `unknown` so call sites can pass raw values without pre-checking the type.
 */
export const isUUID = (value: unknown): boolean =>
  typeof value === "string" && UUID_REGEX.test(value);
